import moment from 'moment';

const dateTimeFormat = function (date) {
  
    let today     = moment(new Date());
    let tomorrow  = moment(new Date()).add(1,'days');
    let yesterday = moment(new Date()).add(-1, 'days');
    let previousYear = moment(new Date()).add(-365, 'days');
    let previousWeek = moment(new Date()).add(-7, 'days');


    if(moment(date).isSame(today, 'day')) {
      return 'Today'
    } else if (moment(date).isSame(tomorrow, 'day')) {
      return 'Tomorrow'
    } else if (moment(date).isSame(yesterday, 'day')) {
      return 'Yesterday'
    } else if (moment(date).isBefore(previousYear)) {
      return moment(date).format("MMMM D, YYYY")
    } else {
      return moment(date).format("MMMM D")
    }

};

export default dateTimeFormat
